<form [formGroup]="parentForm">
  <p-table
    [columns]="tableCols"
    [value]="tableData"
    [(selection)]="selectedProducts"
    (onRowReorder)="onRowReorder($event)"
    dataKey="id"
    class="c-similar-angular-grid c-select-payment-tender"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th style="width: 5em">Priority</th>
        <th style="width: 3em"></th>
        <!-- <th style="width: 3em"></th> -->
        <th *ngFor="let col of tableCols">
          {{ col.header }}
        </th>
        <th style="width: 3em"></th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-rowData
      let-columns="tableCols"
      let-index="rowIndex"
      let-expanded="expanded"
    >
      <tr [pSelectableRow]="rowData" [pReorderableRow]="index">
        <!-- [pReorderableRowDisabled]="index > 2" -->

        <td>
          {{ index + 1 }}
        </td>
        <td>
          <mat-icon aria-hidden="false" aria-label="Example home icon" pReorderableRowHandle
            >reorder</mat-icon
          >
        </td>
        <td *ngFor="let col of tableCols">
          <div class="file-input-container" *ngIf="col.field === 'mediaPath'">
            <button
              class="choose-button"
              [matTooltip]="getFileName(rowData)"
              (click)="fileInput.click()"
              style="max-width: 250px;width: 200px;overflow: hidden;height: 50px;"
            >
              <!-- {{form.get(authControlKey).at(i).get('buttonName').value}} -->
              {{getFileName(rowData)}}
            </button>
            <input
              type="file"
              #fileInput
              class="file-input"
              (change)="onFileChange($event,rowData)"
              accept=".jpeg,.png,.bmp,.mp4,.mov,.mkv"
              [attr.disabled]="action === 'view' ? 'disabled': null"
            />
            <mat-error
              class="error-message"
              *ngIf="col.field === 'mediaPath'&& rowData['mediaType']==='Image' &&parentForm 
                       && parentForm['controls'] 
                       &&  parentForm['controls'][index] 
                       && parentForm['controls'][index]['controls']['mediaPath'] 
                       && parentForm['controls'][index]['controls']['mediaPath'].hasError('required')"
            >
              {{ "module-assignment.engage_settings.image_validation" | translate}}
            </mat-error>
            <mat-error
              class="error-message"
              *ngIf="col.field === 'mediaPath' && rowData['mediaType']===''"
            >
              {{ "module-assignment.engage_settings.image_size_validation" | translate}}
            </mat-error>
            <!-- <div class="file-name">{{'campaign.categorie_screen.image_size_note' | translate}}</div> -->
          </div>
          <!-- <div class="fileTYpeInput">
            <input
              *ngIf="col.field === 'media'"
              type="file"
              [attr.disabled]="action === 'view' ? 'disabled': null"
              formControlName="{{ rowData[col.field] }}"
              id="{{ rowData[col.field] }}"
              (change)="onFileChange($event, rowData)"
              accept=".jpeg,.png,.bmp"
            />
            <span *ngIf="col.field === 'media'"
              >Selected Image:
              <input
                id="readUrl"
                [value]="getSelectedMediaPath(rowData)"
                class="readonlyInput"
                type="text"
                formControlName="readUrl"
                readonly
            /></span>
          </div> -->
          <mat-form-field *ngIf="col.field === 'mediaDuration'" class="mat-block">
            <input
              [value]="getDuration(rowData)"
              id="{{ rowData[col.field] }}"
              matInput
              (input)="onInputChange($event,rowData)"
              [disabled]="action === 'view' || disable(rowData)"
            />
          </mat-form-field>
          <mat-error
            class="error-message"
            *ngIf="col.field === 'mediaDuration'
                     && parentForm && parentForm['controls'] 
                     &&  parentForm['controls'][index] 
                     && parentForm['controls'][index]['controls']['mediaDuration'] 
                     && parentForm['controls'][index]['controls']['mediaDuration'].hasError('required')"
          >
            {{"module-assignment.engage_settings.duration_validation" | translate}}
          </mat-error>
        </td>
        <td>
          <button
            style="background-color: transparent;
      color: #000000;padding-right: 20px "
            [disabled]="action=='view'"
            mat-icon-button
            (click)="delete(rowData)"
            color="primary"
            [disabled]="action === 'view'"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</form>
